var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Menu } from '@headlessui/react';
import cn from "classnames";
var DropDown = function (props) {
    var children = props.children, _a = props.className, className = _a === void 0 ? "" : _a, restprops = __rest(props, ["children", "className"]);
    return (_jsx(Menu, __assign({ as: "div", className: cn(" font-texts text-base w-52 ", className) }, restprops, { children: children })));
};
var Button = function (props) {
    var children = props.children, className = props.className, restprops = __rest(props, ["children", "className"]);
    return (_jsx(Menu.Button, __assign({ className: cn("p-1 rounded w-52", className) }, restprops, { children: children })));
};
var Items = function (props) {
    var children = props.children, className = props.className, restProps = __rest(props, ["children", "className"]);
    return (_jsx(Menu.Items, __assign({ className: cn("p-1 rounded mt-2 left-0 shadow bg-surface-0 z-10  w-52 overflow-y-auto ", className) }, restProps, { children: children })));
};
var Item = function (props) {
    var children = props.children, className = props.className, restProps = __rest(props, ["children", "className"]);
    return (_jsx(Menu.Item, __assign({ as: "div", className: cn("p-3 hover:bg-surface-100 font-texts text-base w-full", className) }, restProps, { children: children })));
};
DropDown.Button = Button;
DropDown.Item = Item;
DropDown.Items = Items;
export default DropDown;
//# sourceMappingURL=DropDown.js.map